<template>
    <footer class="footer">
        <b-container>
            <b-row>
                <b-col cols="12" md="4">
                    <p class="footer-title">LINKS</p>
                    <ul class="footer-nav">
                        <li
                            v-for="nav of navs"
                            :key="nav.name"
                            class="footer-nav-item"
                        >
                            <font-awesome-icon icon="location-arrow" />
                            <router-link :to="nav.to">{{nav.name}}</router-link>
                        </li> 
                    </ul>
                </b-col>
                <b-col cols="12" md="4">
                    <p class="footer-title">CONTACT INFO</p>
                    <p class="footer-text">{{info.title}}</p>
                    <ul class="footer-contact">
                        <li
                            v-for="(item,i) of info.detail"
                            :key="i"
                            class="footer-contact-item"
                        >
                            <div class="icon"><font-awesome-icon :icon="item.icon" /></div>
                            <div class="text">{{item.text}}</div>
                        </li> 
                    </ul>
                </b-col>
                <b-col cols="12" md="4" class="footer-cer">
                    <p class="footer-title">CERTIFICATION</p>
                    <p v-for="item in certification" :key="item.name" class="footer-text">{{item.name}}</p>
                </b-col>
                <b-col cols="12" class="copyright">
                    <p class="footer-cp mb-0">Copyright Scan Top Enterprise Co., Ltd. Taiwan Products, B2BChinaSources, B2BManufactures</p>
                </b-col>
            </b-row>
        </b-container>
    </footer>
</template>

<script>
export default {
    data() {
        return {
            navs: [
                { name: 'HOME', to: { name: 'home'} },
                { name: 'ABOUT US', to: { name: 'about'} },
                { name: 'PRODUCTS', to: { name: 'products'} },
                { name: 'PRODUCTION', to: { name: 'production'} },
                { name: 'LABORATORY', to: { name: 'laboratory'} },
                { name: 'TRADE SHOWS', to: { name: 'trade-shows'} },
                { name: 'CONTANT US', to: { name: 'contact'} },
            ],
            info:{
                title: 'Scan Top Enterprise Co., Ltd.',
                detail: [
                    { 'icon': 'map-marker-alt', 'text': '22F-2, No. 33, Sec. 1, Minsheng Rd., Banqiao Dist., New Taipei City 22069, Taiwan'},
                    { 'icon': 'phone-alt', 'text': '886-2-2957-3478'},
                    { 'icon': 'fax', 'text': '886-2-2957-3288'},
                    { 'icon': 'envelope', 'text': 'wiper@scantop.com.tw'},
                ]
            },
            certification: [
                { name: 'Business Social Compliance Initiative' },
                { name: 'IATF 16949 : 2016' }
            ]
        }
    },
}
</script>

<style lang="scss">
    .footer{
        bottom: 0px;
        z-index: 10;
        width: 100%;
        min-height: 50px;
        padding: 50px 0 10px;
        color: #fff;
        background-size: cover;
        background-repeat: no-repeat;
        background-color: transparent;
        background-image: url('~@/assets/images/home/footer_bg.jpg');
        
        &-title{
            width: 90%;
            margin-bottom: 20px;
            font-size: 18px;
            font-weight: bold;
            letter-spacing: 2px;
            line-height: 2;
            border-bottom: 2px dashed white;
        }

        &-nav{
            padding-left: 5px;
            &-item{
                display: flex;
                align-items: center;
                line-height: 2.2;
                font-size: 13px !important;
                letter-spacing: 2px;

                svg{
                    margin-right: 20px;
                    transform: rotate(45deg);
                }
                a{
                    flex: 1 0 auto;
                    transition: padding 0.3s, color 0.6s;
                    &:hover{
                        padding-left: 10px;
                        color: #fafafa
                    }
                }
            }
        }

        &-contact{
            &-item{
                display: flex;
                align-items: center;
                margin: 12px 0;
                font-size: 12px !important;
                .icon{
                    flex: 0 0 auto;
                    display:flex;
                    align-items: center;
                    justify-content: center;
                    margin-right: 20px;
                    width: 25px;
                    height: 25px;
                    background:#fff;
                    border-radius: 150px;

                    svg{
                        color: rgb(34, 101, 157)
                    }
                }
            }
        }
        &-text {
            margin-bottom: 8px;
            font-size: 12px;
        }
        &-cp {
            font-size: 0.8rem;
        }
    }
    .copyright{
        // position: absolute !important;
        bottom: 0;
        left: 0; right:0 ;
        padding: 8px 0;
        text-align: center;
        background-color: rgba(255,255,255,0.12);
        color: #fff;
        font-size: 12px;
    }
    @media (min-width: 768px) {
        .copyright{
            position: absolute !important;
        }
    }
</style>